import { createContext, useContext } from 'react';

/**
 * Per-page font factor override. Wraps each page in a provider that holds
 * its own override value (null = use the embedded viewport's computed default).
 *
 * `EmbeddedSvgViewport` and `BlueprintPanelCard` read this context. When the
 * value is non-null it replaces the controller-derived font factor entirely
 * (no zoom compensation on top), giving the user direct control.
 */
export const PageFontFactorContext = createContext<number | null>(null);

export const usePageFontFactorOverride = (): number | null => {
	return useContext(PageFontFactorContext);
};

/**
 * Setter context: the viewport/panel-card reports its computed font factor
 * (with zoom compensation) so the font control can display the actual value
 * being used — not the raw controller default.
 */
export const PageReportComputedFactorContext = createContext<(value: number) => void>(() => {});

export const useReportComputedFontFactor = (): (value: number) => void => {
	return useContext(PageReportComputedFactorContext);
};
